import { render, staticRenderFns } from "./QIUIPrivacyPolicy.vue?vue&type=template&id=46da1068&"
import script from "./QIUIPrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./QIUIPrivacyPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports